import React from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import WizardPopupInputsGroup from "./WizardPopupInputsGroupItem";

const SortableItem = SortableElement(({ inputObject, inputObjectIndex }) => {
  return <WizardPopupInputsGroup inputObject={inputObject} inputObjectIndex={inputObjectIndex}/>
});

const SortableList = SortableContainer(({ inputFields }) => {
  // const sections = sortByOrder(discountSections);
  return (
    <ul className="fix-ul">
      {inputFields.map((inputObject, inputObjectIndex) => {
        return (
          <SortableItem key={inputObject.id}
                        inputObject={inputObject}
                        index={inputObjectIndex}
                        inputObjectIndex={inputObjectIndex}/>
        )
      })}
    </ul>
  );
});

export default ({ onSortEnd, onSortStart, shouldCancelStart, inputFields }) => {
  return <SortableList inputFields={inputFields}
                       helperClass='sortableHelper'
                       axis={"y"}
                       // pressDelay={100}
                       shouldCancelStart={shouldCancelStart}
                       onSortStart={onSortStart}
                       onSortEnd={onSortEnd} />
}
